import React, {Component} from 'react';
import project1 from './asset/project/1.png';
import project2 from './asset/project/2.png';
import project3 from './asset/project/3.png';
import project4 from './asset/project/4.png';
import project5 from './asset/project/5.webp';
import project6 from './asset/project/6.png';
import project7 from './asset/project/7.png';
import project8 from './asset/project/8.png';
import project9 from './asset/project/9.png';

class InfoComponent extends Component {
  componentDidMount() {
    const disabledButton = document.querySelectorAll('.dis');
    for (let i = 0; i < disabledButton.length; i++) {
      disabledButton[i].addEventListener('click', (e) => {
        alert('Maaf,halaman yang anda tuju tidak bisa diakses');
        e.preventDefault();
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="container pt-4">
          <div className=" p-3">
            <h1 className="text-light-green fs-2">My Project</h1>
            <hr className="my-4 bg-light" />
            <div className="row justify-content-center p-2">
              <div className="col-lg-6 mb-3">
                <div className="card bg-card p-2 text-center project">
                  <img src={project1} className="card-img-top rounded" alt="SIREGAM PROJECT" />
                  <div className="card-body">
                    <h5 className="card-title text-info fw-bold">SIREGAM</h5>
                    <p className="card-text text-white">
                      SIREGAM is an application created to record student activities during online learning activities. This application has several features such as making schedules, providing reports and attendance
                    </p>
                    <p className="mt-2 text-info">PHP, CSS, Javascript, MySQL , Bootstrap</p>
                  </div>
                  <div className="card-footer">
                    <a href="https://github.com" className="btn btn-dark dis">
                      Demo
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="card bg-card p-2 text-center project">
                  <img src={project2} className="card-img-top rounded" alt="COVID-19 Test" />
                  <div className="card-body">
                    <h5 className="card-title text-info fw-bold">COVID-19 Test</h5>
                    <p className="card-text text-white">COVID-19 test is an application that functions as a test of the risk of transmitting COVID-19 to you, by going through several tests in the form of questions.</p>
                    <p className="mt-2 text-info">PHP, CSS, Javascript, MySQL , Bootstrap</p>
                  </div>
                  <div className="card-footer">
                    <a href="https://github.com" className="btn btn-dark dis">
                      Demo
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="card bg-card p-2 text-center project">
                  <img src={project3} className="card-img-top rounded" alt="Bangkit Jaya" />
                  <div className="card-body">
                    <h5 className="card-title text-info fw-bold">Bangkit Jaya</h5>
                    <p className="card-text text-white">
                      Bangkit Jaya is a website company, serves as a website for promotion, providing info about the company and information about sales. This website has features to add new data for sales and upload images..
                    </p>
                    <p className="mt-2 text-info">Laravel, CSS, Javascript, MySQL , Bootstrap</p>
                  </div>
                  <div className="card-footer">
                    <a href="https://bangkitjayacompany.com" target="_blank" rel="noreferrer" className="btn btn-dark">
                      Demo
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="card bg-card p-2 text-center project">
                  <img src={project4} className="card-img-top rounded" alt="Kantin Wikrama" />
                  <div className="card-body">
                    <h5 className="card-title text-info fw-bold">Kantin Wikrama</h5>
                    <p className="card-text text-white">
                      Kantin Wikrama is a website application that is used for recording everything from stock to entry and exit of goods. This website has features in the form of making a purchase schedule, inputting income, inputting
                      expenses and making monthly reports.
                    </p>
                    <p className="mt-2 text-info">Laravel, CSS, Javascript, MySQL , Bootstrap</p>
                  </div>
                  <div className="card-footer">
                    <a href="https://bangkitjayacompany.com" target="_blank" rel="noreferrer" className="btn btn-dark dis">
                      Demo
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="card bg-card p-2 text-center project">
                  <img src={project5} className="card-img-top rounded" alt="Tropisianimal" />
                  <div className="card-body">
                    <h5 className="card-title text-info fw-bold">Tropisianimal</h5>
                    <p className="card-text text-white">
                      Tropisianimal is a website that contains news about tropical animals in the world. This website has a function like a blog. The features found on this website are login for admin, updating post data and uploading
                      images for the gallery.
                    </p>
                    <p className="mt-2 text-info">Laravel, CSS, Javascript, MySQL , Bootstrap</p>
                  </div>
                  <div className="card-footer">
                    <a href="https://github.com" className="btn btn-dark dis">
                      Demo
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="card bg-card p-2 text-center project">
                  <img src={project6} className="card-img-top rounded" alt="Surat Digital" />
                  <div className="card-body">
                    <h5 className="card-title text-info fw-bold">Surat Digital</h5>
                    <p className="card-text text-white">
                      this is an application website that I created to record the management of incoming and outgoing mail at school. The features of this website are admin and staff logins, mail input, mail filters, disposition, uploading
                      letters, adding users and file galleries.
                    </p>
                    <p className="mt-2 text-info">Laravel, CSS, Javascript, MySQL , Bootstrap</p>
                  </div>
                  <div className="card-footer">
                    <a href="https://github.com/MuhamadIchsan/surat-menyurat-digital" className="btn btn-dark dis">
                      Demo
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="card bg-card p-2 text-center project">
                  <img src={project7} className="card-img-top rounded" alt="SIM Rayon" />
                  <div className="card-body">
                    <h5 className="card-title text-info fw-bold">SIM Rayon</h5>
                    <p className="card-text text-white">SIM Rayon is a school website that is used for recording student activity data, starting from absences, making rayon gathering schedules.</p>
                    <p className="mt-2 text-info">Laravel, CSS, Javascript, MySQL , Bootstrap</p>
                  </div>
                  <div className="card-footer">
                    <a href="https://github.com/MuhamadIchsan/sim-rayon" className="btn btn-dark dis">
                      Demo
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="card bg-card p-2 text-center project">
                  <img src={project8} className="card-img-top rounded" alt="PPDB" />
                  <div className="card-body">
                    <h5 className="card-title text-info fw-bold">PPDB </h5>
                    <p className="card-text text-white">
                      PPDB is a school registration website, this website was created when I took the junior programmer certification. This website has login features for students and admins, uploading, creating and deleting student data.
                    </p>
                    <p className="mt-2 text-info">Laravel, CSS, Javascript, MySQL , Bootstrap</p>
                  </div>
                  <div className="card-footer">
                    <a href="https://github.com/MuhamadIchsan/ppdb2" className="btn btn-dark dis">
                      Demo
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="card bg-card p-2 text-center project">
                  <img src={project9} className="card-img-top rounded" alt="COVID.IN" />
                  <div className="card-body">
                    <h5 className="card-title text-info fw-bold">COVID.IN</h5>
                    <p className="card-text text-white">COVID.IN is a website containing information about COVID-19 globally. The features contained in it are in the form of searching for COVID-19 data by utilizing API data.</p>
                    <p className="mt-2 text-info">React.JS, CSS, Javascript , Bootstrap</p>
                  </div>
                  <div className="card-footer">
                    <a href="https://cov-in.netlify.app" className="btn btn-dark">
                      Demo
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default InfoComponent;
